import * as React from 'react';
import {  View, Text, StyleSheet, Dimensions } from 'react-native';
import { themePattern } from '../../constants/pattern';
import * as WebBrowser from 'expo-web-browser';

import BtnFlatBlackWhite from '../buttons/BtnFlatBlackWhite';


const { width, height } = Dimensions.get('window')



const facebookEIC:any = "https://www.facebook.com/EIC.USP";
const instagramEIC:any = "https://www.instagram.com/eiciencia/";
const youtubeEIC:any = "https://www.youtube.com/c/Espa%C3%A7oInterativodeCi%C3%AAncias/";
const siteEIC:any = "https://eic.ifsc.usp.br/";




export default function Networks() {

  // Função Referencia
  let openFacebook = () => {
    WebBrowser.openBrowserAsync(facebookEIC)
  };

  let openInstagram = () => {
    WebBrowser.openBrowserAsync(instagramEIC)
  };

  let openYoutube = () => {
    WebBrowser.openBrowserAsync(youtubeEIC)
  };

  let openSite = () => {
    WebBrowser.openBrowserAsync(siteEIC)
  };


    
  return (
    <View style={styles.Main}>
      <View style={styles.containerText}>
        <Text style={styles.text}>SIGA O EIC</Text>
        <Text style={styles.textsecundary}>
        Interaja com a gente nas mídias sociais e em nosso site!
        </Text>
      </View>


      <View style={styles.icons}>
          <BtnFlatBlackWhite color='white' icon={'facebook'} key={10} onPress = {openFacebook}/>
          <BtnFlatBlackWhite color='white' icon={'youtube'} key={11} onPress = {openYoutube}/>
          <BtnFlatBlackWhite color='white' icon={'instagram'} key={12} onPress = {openInstagram}/>
          <BtnFlatBlackWhite color='white' icon={'globe'} key={13} onPress = {openSite}/>
      </View>

    </View>
    
  );
}


function Styles() {

  //Mobile
  if(themePattern.breakpoint.mobile >= width)
    return StyleSheet.create({
      Main: {
        padding: 15,
        textAlign: 'center',
        alignContent: 'center', 
        justifyContent: 'space-evenly',
        
        flex:1
      },
      icons:{
          flex: 1,
          flexDirection: 'row',
          justifyContent: 'space-between'
    
    
      }, containerText:{
          flex: 2,
          
          flexDirection: 'column',
          justifyContent: 'center'
      },
      text:{
        fontSize: themePattern.mobile.title1,
        color: themePattern.mobile.white,
        fontWeight: 'bold',
        textAlign:"center"
      },
      textsecundary:{
        fontSize: themePattern.mobile.title3,
        color: themePattern.mobile.black,
        textAlign: 'center'
      },
      destaque:{
          color: themePattern.mobile.color1,
          fontWeight: 'bold'
      }
    });
  
  //Tablet
  else
  return StyleSheet.create({
    Main: {
      padding: 15,
      textAlign: 'center',
      alignContent: 'center', 
      justifyContent: 'space-evenly',
      
      flex:1
    },
    icons:{
        flex: 1,
        flexDirection: 'row',
        justifyContent: 'space-around'
  
  
    }, containerText:{
        flex: 2,
        
        flexDirection: 'column',
        justifyContent: 'center'
    },
    text:{
      fontSize: themePattern.tablet.title1,
      color: themePattern.tablet.white,
      fontWeight: 'bold',
      textAlign:"center"
    },
    textsecundary:{
      fontSize: themePattern.tablet.title2,
      color: themePattern.tablet.black,
      textAlign: 'center'
      
    },
    destaque:{
        color: themePattern.tablet.color1,
        fontWeight: 'bold'
  
  
    }
  });
}

const styles =  Styles()
